async function devtricker_ajax_get_suggestedAccounts() {

    try {

        //The current userId is not necessary for fetching data, but it's used to clear the cache."
        let currentUserId = devtricker_getTheUserId();
        let tagId = parseInt(document.getElementById('tagData')?.getAttribute('data-tag-id') || 0, 10);
        let excludeUserId = devtricker_dom_get_recommendation_account_authorId() || tagId || 0;

        const url = `/wp-admin/admin-ajax.php?action=devtricker_recommendation_account_action_get_recommend_accounts_ajax&user_id=${currentUserId}&tag_id=${tagId}&exclude_id=${excludeUserId}`;

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
        });

        if (!response.ok) {
            throw new Error('Failed to retrieve recommended accounts');
        }

        const htmlContent = await response.text();
        let tmp = document.createElement('div');
        tmp.innerHTML = htmlContent;

        let content = tmp.querySelector('aside')

        return content;

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}